import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Row } from "reactstrap"
import { DateRangePicker } from "rsuite"
import "rsuite/dist/rsuite.min.css"
import { getPredefinedDateRanges } from "helpers/dateRanges"
import {
  getAllDateWiseData,
} from "helpers/backendHelpers/dashboard"
import SubmitLoader from "components/Common/submitLoader"
import "./dashboard.scss"

const Dashboard = () => {

  const [allAnalytics, setAllAnalytics] = useState({})
  const [loading, setLoading] = useState(false)
  const [isHandleChange, setIsHandleChange] = useState(true)

  const formatDisplayDate = value => {
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(new Date(value))
  }

  const getCurrentMonthRange = () => {
    const start = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    const end = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    return [start, end]
  }

  const [dateRange, setDateRange] = useState(getCurrentMonthRange())

  useEffect(() => {
    document.getElementById("dashboard").classList.add("mm-active")
    document.title = "Dashboard | React Admin & Dashboard Template"
    const currentMonth = getCurrentMonthRange()
    setDateRange(currentMonth)
    getDateWiseData(currentMonth)
    // fetchAllAnalytics()
    // getDateWiseData(getCurrentMonthRange())
  }, [])

  const getDateWiseData = async data => {
    let startDate = null
    let endDate = null

    if (Array.isArray(data) && data.length === 2 && data[0] && data[1]) {
      startDate = new Date(data[0]).toISOString()
      endDate = new Date(data[1]).toISOString()
    }

    try {
      setLoading(true)
      let response = await getAllDateWiseData(startDate, endDate)
      response = response?.payload || {}
      if (startDate && endDate) {
        response["date"] = `${formatDisplayDate(startDate)} - ${formatDisplayDate(
          endDate
        )}`
      } else {
        response["date"] = "All time"
      }
      setAllAnalytics(response)
      setIsHandleChange(false)
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }


  const formatMetricValue = value => {
    if (!value) return 0
    if (typeof value === "number") {
      return new Intl.NumberFormat("en-IN").format(value)
    }
    return value
  }

  const selectedDateLabel = isHandleChange ? "This month" : allAnalytics?.date || "All time"

  const getAddonCardStyling = addon => {
    const code = addon?.code
    const isCredit = addon?.cardType === "credit_purchase"

    if (code === "ewayBill") {
      return isCredit
        ? { iconClass: "fas fa-coins", accentClass: "dashboard-card-eway-credit" }
        : { iconClass: "fas fa-file-invoice", accentClass: "dashboard-card-eway" }
    }
    if (code === "whatsappService") {
      return { iconClass: "fab fa-whatsapp", accentClass: "dashboard-card-whatsapp" }
    }
    if (code === "jobManagement") {
      return { iconClass: "fas fa-tasks", accentClass: "dashboard-card-job" }
    }
    return isCredit
      ? { iconClass: "fas fa-coins", accentClass: "dashboard-card-generic-credit" }
      : { iconClass: "fas fa-puzzle-piece", accentClass: "dashboard-card-generic-addon" }
  }

  const reports = [
    {
      title: "New Paid Users Achieve",
      iconClass: "dripicons-user-group",
      count: allAnalytics?.totalMetrics?.totalNewPaidUsersAchieved,
      accentClass: "dashboard-card-users",
    },
    {
      title: "New User Collection Amount",
      iconClass: "fas fa-money-bill-alt",
      count: allAnalytics?.totalMetrics?.totalNewUserCollectionPaymentAmount,
      accentClass: "dashboard-card-collection",
    },
    {
      title: "Renew Amount Collected",
      iconClass: "fas fa-money-bill-alt",
      count: allAnalytics?.totalMetrics?.totalRenewAmountCollected,
      accentClass: "dashboard-card-renewal",
    },
    {
      title: "Total New Registrations",
      iconClass: "dripicons-user-group",
      count: allAnalytics?.totalMetrics?.newRegistrations,
      accentClass: "dashboard-card-registrations",
    },
    {
      title: "Total GST Payable",
      iconClass: "fas fa-file-invoice-dollar",
      count: allAnalytics?.totalMetrics?.totalGSTPayable,
      accentClass: "dashboard-card-collection",
    },
  ]

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid className="dashboard-page">
          <div className="dashboard-hero">
            <div className="dashboard-hero__content">
              <h4 className="dashboard-hero__title">Dashboard</h4>
            </div>

            <div className="dashboard-filter-card dashboard-filter-card--simple">
              <div className="dashboard-filter-card__wrapper">
                <DateRangePicker
                  placeholder="Select Date ..."
                  value={Array.isArray(dateRange) && dateRange.length === 2 ? dateRange : null}
                  format="dd/MM/yyyy"
                  showOneCalendar
                  block
                  ranges={getPredefinedDateRanges()}
                  placement="bottomEnd"
                  onChange={value => {
                    setDateRange(value || [])
                    getDateWiseData(value)
                  }}
                />
              </div>
              <span className="dashboard-filter-card__range">
                {selectedDateLabel}
              </span>
            </div>
          </div>

          {loading ? <SubmitLoader /> : <></>}
          <Row className="g-4">
            {reports.map((report, key) => (
              <Col xl="3" md="6" key={"_col_" + key}>
                <Card className={`mini-stats-wid dashboard-stat-card ${report.accentClass}`}>
                  <CardBody className="dashboard-stat-card__body">
                    <div className="dashboard-stat-card__content">
                      <span className="dashboard-stat-card__label">
                        {report.title}
                      </span>
                      <h4 className="dashboard-stat-card__value">
                        {formatMetricValue(report.count)}
                      </h4>
                      <span className="dashboard-stat-card__meta">
                        {selectedDateLabel}
                      </span>
                    </div>

                    <div className="dashboard-stat-card__icon">
                      <span className="avatar-title rounded-circle">
                        <i className={report.iconClass + " font-size-24"}></i>
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          {Array.isArray(allAnalytics?.addonMetrics) && allAnalytics.addonMetrics.length > 0 && (
            <React.Fragment>
              <div className="dashboard-section-header">
                <h5 className="dashboard-section-header__title">
                  Add-on Overview
                </h5>
              </div>

              <Row className="g-4">
                {allAnalytics.addonMetrics.map((addon, key) => {
                  const styling = getAddonCardStyling(addon)
                  return (
                    <Col xl="3" md="6" key={"_addon_col_" + key}>
                      <Card className={`mini-stats-wid dashboard-stat-card ${styling.accentClass}`}>
                        <CardBody className="dashboard-stat-card__body">
                          <div className="dashboard-stat-card__content w-100">
                            <span className="dashboard-stat-card__label">
                              {addon.title}
                            </span>
                            <h4 className="dashboard-stat-card__value">
                              ₹ {formatMetricValue(addon.totalAmount)}
                            </h4>
                            <div className="dashboard-addon-stats d-flex flex-wrap gap-2 my-1">
                              <span className="dashboard-addon-chip dashboard-addon-chip--users">
                                <i className="dripicons-user-group me-1"></i>
                                {formatMetricValue(addon.customerCount)} Customers
                              </span>
                              {addon.hasCredits && (
                                <span className="dashboard-addon-chip dashboard-addon-chip--credits">
                                  <i className="fas fa-bolt me-1"></i>
                                  {formatMetricValue(addon.totalCredits || 0)} Credits
                                </span>
                              )}
                            </div>
                            <span className="dashboard-stat-card__meta">
                              {selectedDateLabel}
                            </span>
                          </div>

                          <div className="dashboard-stat-card__icon">
                            <span className="avatar-title rounded-circle">
                              <i className={styling.iconClass + " font-size-24"}></i>
                            </span>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  )
                })}
              </Row>
            </React.Fragment>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard
